import {Injectable} from '@angular/core';
import {HttpClient } from '@angular/common/http';
import {Observable} from "rxjs";
import {CounterStatus} from "./counterStatus";
import {UrlBuilder} from "../url-builder/url.builder";


@Injectable({
  providedIn: 'root'
})
export class CounterStatusDataservice {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<CounterStatus> {
    this.uiUrl = this.url.GetCounterUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<CounterStatus>(this.uiUrl);
  }

}


